import { Component, inject, Input, OnInit, signal } from '@angular/core';
import { ApplicationStatusEnum, BriefStatusProgressDto } from '../../../../../common/general-types/briefs.dto';
import { FormatService } from '../../../../../common/format/format.service';
import { NoodleBriefQuestionGroupDto, NoodleQuestionDto } from '../../../../../common/general-types/noodle.dto';
import { NoodleService } from '../../../../../services/noodle/noodle.service';
import { Router } from '@angular/router';

@Component({
  selector: 'brief-feed-vqa-extracted',
  standalone: true,
  imports: [],
  templateUrl: './feed-vqa-extracted.component.html',
  styleUrl: './feed-vqa-extracted.component.css'
})
export class FeedVqaExtractedComponent implements OnInit {

  @Input('activity') activity!: {
    applicationStatus: ApplicationStatusEnum;
    briefStatusProgress: BriefStatusProgressDto;
    date: Date;
  }

  briefQuestions = signal<NoodleBriefQuestionGroupDto | undefined>(undefined);
  doQuestions = signal<NoodleQuestionDto[] | undefined>(undefined);
  dontQuestions = signal<NoodleQuestionDto[] | undefined>(undefined);

  needEnrichmentQuestions = signal<NoodleQuestionDto[] | undefined>(undefined);

  /** Services */
  private router = inject(Router);
  public formatService = inject(FormatService);
  private noodleService = inject(NoodleService);
  /** Services END */

  ngOnInit(): void {
    console.log('Feed VQA Extracted Activity: ', this.activity);
    if (this.activity.briefStatusProgress.briefId) {
      this.getBriefQuestions(this.activity.briefStatusProgress.briefId);
    }
  }

  getBriefQuestions(briefId: string) {
    this.noodleService.getBriefQuestions(briefId).subscribe((questions: NoodleBriefQuestionGroupDto) => {
      console.log('questions: ', questions);
      this.briefQuestions.set(questions);
      this.doQuestions.set(questions.questions.filter((question: NoodleQuestionDto) => question.type === 'do'));
      this.dontQuestions.set(questions.questions.filter((question: NoodleQuestionDto) => question.type === 'dont'));
      this.needEnrichmentQuestions.set(questions.questions.filter((question: NoodleQuestionDto) => question.generalised));
    });
  }

  enrichBrief() {
    this.router.navigate(['/brief-enhancements', this.activity.briefStatusProgress.briefId]);
  }
}
